const experience = [
    { value: "0-1 year", label: "0-1 year" },
    { value: "1-2 years", label: "1-2 years" },
    { value: "2-3 years", label: "2-3 years" },
    { value: "3-4 years", label: "3-4 years" },
    { value: "4-5 years", label: "4-5 years" },
    { value: "5-6 years", label: "5-6 years" },
    { value: "6-7 years", label: "6-7 years" },
    { value: "7-8 years", label: "7-8 years" },
    { value: "8-9 years", label: "8-9 years" },
    { value: "9-10 years", label: "9-10 years" },
    { value: "10-11 years", label: "10-11 years" },
    { value: "11-12 years", label: "11-12 years" },
    { value: "12-13 years", label: "12-13 years" },
    { value: "13-14 years", label: "13-14 years" },
    { value: "14-15 years", label: "14-15 years" },
    { value: "15-16 years", label: "15-16 years" },
    { value: "16-17 years", label: "16-17 years" },
    { value: "17-18 years", label: "17-18 years" },
    { value: "18-19 years", label: "18-19 years" },
    { value: "19-20 years", label: "19-20 years" },
    { value: "20-21 years", label: "20-21 years" },
    { value: "21-22 years", label: "21-22 years" },
    { value: "22-23 years", label: "22-23 years" },
    { value: "23-24 years", label: "23-24 years" },
    { value: "24-25 years", label: "24-25 years" },
    { value: "25-26 years", label: "25-26 years" },
    { value: "26-27 years", label: "26-27 years" },
    { value: "27-28 years", label: "27-28 years" },
    { value: "28-29 years", label: "28-29 years" },
    { value: "29-30 years", label: "29-30 years" },
    { value: "30+ years", label: "30+ years" },
];

export default experience;